import React, { Component } from 'react';

import FormulaireSelectionProjet from '../../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';

import { jsDictionaryEquals } from '../../../../../ressources/functionJS/jsDictionaryEquals';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import * as glossaire_pattern from '../../../../../ressources/glossaires/glossaire_pattern';

import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireRapportGenere.module.scss';
import FormulaireSelectionDateHeureUnix from '../../../../Graphe/ProfilGraphe/FormulaireGraphe/FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';

/**
 * Affichage des informations d'un rapport généré.
 *
 * Lecture seule : un rapport généré est produit par le serveur à partir d'un
 * rapport gabarit, et l'API ne propose ni de le créer ni de le modifier
 * (seulement générer, lister, publier et supprimer). Le composant envoyait
 * autrefois une requête de création ou de modification d'alarme XY, reste
 * d'une copie de FormulaireAlarmeXY qu'aucun bouton n'appelait ; ce code a été
 * retiré.
 */
class FormulaireRapportGenere extends Component {
  state = {
    template_id: null,
    path_report: null,
    creation_time: null,
  };

  // setState fusionne déjà l'objet reçu avec l'état : les appels ci-dessous ne
  // recopient pas this.state. Cette copie écrasait la pré-configuration.
  // componentDidMount la met en file ; FormulaireSelectionProjet appelle
  // ensuite gererProjetId depuis son useEffect, que React 17 exécute avant
  // d'appliquer cette file. this.state valait encore l'état initial, et
  // { ...this.state, project_id } remettait tous les champs à null : le profil
  // s'affichait vide.
  componentDidMount() {
    if (this.props.preconfigurerRapportGenere !== undefined) {
      this.setState({ ...this.props.preconfigurerRapportGenere });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.preconfigurerRapportGenere !== undefined &&
      !jsDictionaryEquals(
        prevProps.preconfigurerRapportGenere,
        this.props.preconfigurerRapportGenere
      )
    ) {
      this.setState({ ...this.props.preconfigurerRapportGenere });
    }
  }

  gererEtatDeCibleName = (event) =>
    this.setState({ [event.target.name]: event.target.value });
  gererProjetId = (projetId) => this.setState({ project_id: projetId });
  affichageFormulaire = (style, label_state, label_name, pattern) => {
    /**
     * permet d'afficher un composant input de gestion de la modification
     */

    switch (pattern) {
      case glossaire_pattern.unix_timestamp:
        return (
          <div className={[style, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            {/**DEBUT last_unixtimestamp_run**/}
            <FormulaireSelectionDateHeureUnix
              value={
                this.props.preconfigurerRapportGenere !== undefined
                  ? this.state[label_state]
                  : null
              }
              gereUnixDate={(event) => this.gererEtatDeCibleName(event)}
              disabled={this.props.affichageProfil === true}
            />
            {/**FIN last_unixtimestamp_run**/}
          </div>
        );
      default:
        return (
          <div className={[style, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={[s.form_control].join(' ')}
              placeholder={label_state}
              name={label_state}
              // Toujours l'état : value null rendait le champ non contrôlé.
              value={this.state[label_state] ?? ''}
              disabled={this.props.affichageProfil === true}
              onChange={(event) => this.gererEtatDeCibleName(event)}
            />
          </div>
        );
    }
  };

  render() {
    return (
      <>
        <div className={[s.row].join(' ')}>
          <div className={styles.ConteneurInfo}>
            <div className={[s.container, s.text_left].join(' ')}>
              <form onSubmit={(event) => event.preventDefault()}>
                <div className={s.form_group}>
                  <div className={[s.form_row, s.align_items_center].join(' ')}>
                    {/**DEBUT project_id**/}
                    <FormulaireSelectionProjet
                      affichageProfil={this.props.affichageProfil}
                      gererProjetId={this.gererProjetId}
                      preconfigurerProjetId={this.state.project_id}
                    />
                    {/**FIN project_id**/}
                    {/**DEBUT path_report**/}
                    {this.affichageFormulaire(
                      s.col_12,
                      'path_report',
                      checkMot('path_report'),
                      glossaire_pattern.integer
                    )}
                    {/**FIN path_report**/}
                    {/**DEBUT creation_time**/}
                    {this.affichageFormulaire(
                      s.col_12,
                      'creation_time',
                      checkMot('creation_time'),
                      glossaire_pattern.unix_timestamp
                    )}
                    {/**FIN creation_time**/}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default FormulaireRapportGenere;
